import { fetchStartupRead } from './startupRequests';

/** Restore the app gate when a protected request reveals an unseen prompt. */
export function notifyChatFeedbackRequired(status: number, body: unknown): void {
  if (status !== 423 || !body || typeof body !== 'object') return;
  const detail = (body as { detail?: unknown }).detail;
  if (!detail || typeof detail !== 'object') return;
  const required = detail as { code?: unknown; prompt?: unknown };
  if (required.code !== 'CHAT_FEEDBACK_REQUIRED') return;
  window.dispatchEvent(new CustomEvent('chat-feedback-required', {
    detail: required.prompt,
  }));
}

/** Keep the caller's response stream intact while recovering a blocked app. */
export async function fetchWithChatFeedback(
  input: RequestInfo | URL,
  init?: RequestInit,
  fetchImpl?: typeof fetch,
): Promise<Response> {
  const response = await fetchStartupRead(input, init, fetchImpl);
  if (response.status === 423) {
    try {
      notifyChatFeedbackRequired(response.status, await response.clone().json());
    } catch {
      // Invalid error bodies retain the caller's existing error/fallback path.
    }
  }
  return response;
}
